import { Box } from '@mui/material'

import { Page } from 'Common/Page/Page'
import { PageHeader } from 'Common/Supplyvue-ui'
import { useSettingsContext } from 'Features/Projects/Scenarios/EditSettings/EditSettings.types'
import { useWindowSize } from 'Common/hooks/useWindowSize.hook'
import { max } from 'lodash'

import { NetworkCapacitiesTable } from './Capacities.Table'
import { useNetworkCapacities } from './Capacities.data'

export const NetworkCapacitiesView = () => {
  const { state } = useSettingsContext()
  const { projectId, scenarioId } = state
  const { view_width, view_height } = useWindowSize()

  const { data: networkCapacitiesData, isLoading } = useNetworkCapacities({
    projectId,
    scenarioId,
  })

  return (
    <Page>
      <Box
        display="flex"
        flex="auto"
        flexDirection="column"
        justifyContent="flex-start"
        maxWidth={view_width}
        maxHeight={max([view_height, 1500])}
      >
        <PageHeader title="Network Capacities" />
        <NetworkCapacitiesTable
          data={networkCapacitiesData ?? []}
          isLoading={isLoading}
        />
      </Box>
    </Page>
  )
}
